import { render, staticRenderFns } from "./ModalityRegister.vue?vue&type=template&id=e48d0d6a"
import script from "./ModalityRegister.vue?vue&type=script&lang=js"
export * from "./ModalityRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e48d0d6a')) {
      api.createRecord('e48d0d6a', component.options)
    } else {
      api.reload('e48d0d6a', component.options)
    }
    module.hot.accept("./ModalityRegister.vue?vue&type=template&id=e48d0d6a", function () {
      api.rerender('e48d0d6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/grid/ModalityRegister.vue"
export default component.exports